import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import classes from "./AuthLayout.module.css";
import loginImg from "../Assests/Images/loginVecor.png";
import appLogo from "../Assests/Images/loginlogo.svg";

function AuthLayout() {
  const location: any = useLocation();
  const { pathname } = location;

  return (
    <>
      <div className={`row ${classes.login_container}`}>
        <div
          className={`col-lg-6 col-md-5 col-0 p-0 ${classes.loginImageContainer}`}
        >
          <div>
            <img src={loginImg} alt="loginImg" />
          </div>
        </div>

        <div
          className={`col-lg-6 col-md-7 col-12 p-md-0 ${classes.contentContainer}`}
        >
          <div className={classes.login_water_marker_img}>
            {pathname !== "/forgtcredentials" ? (
              <div
                className={classes.login_bg}
                style={{ maxWidth: pathname == "/register" ? "900px" : "" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <img
                    className={`img-auto ${classes.appLogo}`}
                    src={appLogo}
                    alt="appLogo"
                  />
                  <p className={classes.appText}>M-POWER</p>
                </div>
                <Outlet />
              </div>
            ) : (
              <Outlet />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AuthLayout;
